export const christmasWithoutSnowId = "Christmas (without snow)";
export const christmasId = "Christmas";
export const christmasPeppermintHolidayId = "Christmas (Peppermint)";
export const darkThemeId = "Dark";
export const feastOfSaintPatrickId = "Feast of Saint Patrick";
export const flamingoId = "Flamingo";
export const funId = "Fun";
export const grayscaleId = "Grayscale";
export const greenscaleId = "Greenscale";
export const lightThemeId = "Light";
export const volcanicAshId = "Volcanic Ash";
export const prideClassicId = "Pride (classic)";
export const prideVibrantId = "Pride (Vibrant)";
export const valentinesDayId = "Valentines Day";
export const halloweenId = "Halloween";
export const aSuperSpecialAutoThemeSettingsId = "Auto Seasonal Rotate";
